import * as core from '../../../../../../../core'
import * as changeImpactDepartment from '../change-impact-department'

export const RESOURCE = {
  payload: {
    description: 'Alumni Relations',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactDepartment.RESOURCE.payload.partialId,
    }),
    id: 'Alumni Relations',
    name: 'Alumni Relations',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
